module.exports = __webpack_public_path__ + "resources/img/certi_cloud_service.ea5794a68c9d2a75f4cf61cdadc709fc.png";